// extracted by mini-css-extract-plugin
export var list = "langList-module--list--36aov";
export var link = "langList-module--link--33ryk";
export var activeLink = "langList-module--activeLink--3fgfO";